<template><div><h1 id="adressanderungen" tabindex="-1"><a class="header-anchor" href="#adressanderungen"><span>Adressänderungen</span></a></h1>
<p>Adressänderung — Ausgabe von Adressänderungen innnerhalb eines bestimmten Datumsbereiches</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit diesem Report werden Adressänderungen ausgelistet, die sich innerhalb eines definierbaren Datumsbreichs befinden. Die Auswahl der Personen kann mit einem Personenfilter und nach Merkmal eingeschränkt werden.</p>
<h2 id="pfad" tabindex="-1"><a class="header-anchor" href="#pfad"><span>Pfad</span></a></h2>
<p>Personen → Auswertungen → Adressänderungen</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Änderungsdatum von/bis</dt>
<dd>Nur Adressänderungen, die in diesem Datumsbereich vorgenommen worden sind, werden ausgelistet.</dd>
<dt>Personenfilter</dt>
<dd>Einschränkung der Auswahl mit <a class="link" href="ft.refdata.adrfilter.html" title="Personenfilter Kopf">Personenfilter</a></dd>
<dt>und nur mit Merkmal</dt>
<dd>Zusätzliche Einschränkung nach <a class="link" href="../../manual/customer/merkmale.html" title="8. Merkmale">Merkmal</a> oder Merkmalknoten. .</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Birt-Report mit Darstellung der Adressänderungen alt/neu.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.adrfilter.html" title="Personenfilter Kopf">Personenfilter</RouteLink> , <RouteLink to="/manual/customer/merkmale.html" title="8. Merkmale">Merkmale</RouteLink></p>
</div></template>


